export enum LocationType {
    All = 'all',
    Region = 'region',
    Cluster = 'cluster',
    Store = 'store'
}

export enum CalendarActionType {
    Save = 'save',
    Approve = 'approve'
}

export enum OpenBtnType {
    All = 'OPEN_ALL',
    Districts = 'OPEN_DISTRICTS',
    Shops = 'OPEN_SHOPS'
}

export enum CalendarType {
    CREATE = 'create',
    INFO = 'info',
    EDIT = 'edit'
}
